const ModerationReportModule = () => import('@pages/reports/ModerationReport/ModerationReportModule')
const ModerationReportIndex = () => import('@pages/reports/ModerationReport/ModerationReportIndex')
export default {
    path: 'reports',
    component: ModerationReportModule,
    children: [{
        path: 'moderation-report',
        component: ModerationReportIndex,
        name: 'moderationReport'
    }]
}
